import { KeyValue } from '@/main/models/common';
import {
  ExcludeVariablesTypes,
  ExcludeVariablesActionTypes
} from './excludeVariablesTypes';

export function getExcludeVariables(
  request: string,
  keyReducer: string = 'default'
): ExcludeVariablesActionTypes {
  return {
    type: ExcludeVariablesTypes.GET_EXCLUDE_VARIABLES,
    payload: { request, keyReducer }
  };
}

export function saveExcludeVariables(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null,
  keyReducer: string = 'default'
): ExcludeVariablesActionTypes {
  return {
    type: ExcludeVariablesTypes.SAVE_EXCLUDE_VARIABLES,
    payload: { data, isError, errorMessages, keyReducer }
  };
}

export function resetReducerExcludeVariables(): ExcludeVariablesActionTypes {
  return {
    type: ExcludeVariablesTypes.RESET_REDUCER_EXCLUDE_VARIABLES
  };
}
